import { apiClient } from './client';
import { TrainingCatalogueEntry, TrainingRequest } from '../types/training';

export const trainingApi = {
  catalogue: () => apiClient.get<{ data: TrainingCatalogueEntry[] }>('/api/training-catalogue'),
  myRequests: () => apiClient.get<{ data: TrainingRequest[] }>('/api/training/my-requests'),
  request: (input: { catalogueId?: number; trainingTitle?: string; trainingProvider?: string; reason?: string; proposedDate?: string }) =>
    apiClient.post<{ data: { id: number; status: string } }>('/api/training/request', input),
  pendingForSupervisor: () => apiClient.get<{ data: TrainingRequest[] }>('/api/training/pending-supervisor-review'),
  supervisorDecide: (id: number, input: { decision: 'approved' | 'rejected' }) =>
    apiClient.post<{ data: { status: string } }>(`/api/training/${id}/supervisor-decide`, input),
  pendingForHR: () => apiClient.get<{ data: TrainingRequest[] }>('/api/training/pending-hr-review'),
  listForEmployee: (employeeId: number) => apiClient.get<{ data: TrainingRequest[] }>(`/api/employees/${employeeId}/training`),
  hrDecide: (id: number, input: { decision: 'approved' | 'rejected' }) =>
    apiClient.post<{ data: { status: string } }>(`/api/training/${id}/hr-decide`, input),
  complete: (id: number, input: { certificateNotes?: string }) =>
    apiClient.post<{ data: { status: string } }>(`/api/training/${id}/complete`, input),
  supervisorReturn: (id: number, comment: string) => apiClient.post<{ data: { status: string } }>(`/api/training/${id}/supervisor-return`, { comment }),
  hrReturn: (id: number, comment: string) => apiClient.post<{ data: { status: string } }>(`/api/training/${id}/hr-return`, { comment }),
  resubmit: (id: number) => apiClient.post<{ data: { status: string } }>(`/api/training/${id}/resubmit`),
};
